import React, { Fragment } from 'react'
import { AsyncTypeahead, Highlighter, Menu, MenuItem } from 'react-bootstrap-typeahead'
import 'react-bootstrap-typeahead/css/Typeahead.css'
import { FetchRequest } from '@rails/request.js'

const Error = ({ error }) => {
  return <p className='inline-errors my-2'>{error}</p>
}

export default class MultiSelectTypeaheadInput extends React.Component {
  constructor(props) {
    super(props)

    let initialValues = []
    if (props.selected) {
      initialValues = props.selected.map(value => ({
        label: value.label,
        value: value.id
      }))
    }

    this.state = {
      isLoading: false,
      initialValues: initialValues,
      selectedRecords: initialValues,
      options: props.inititalOptions,
      ...props
    }

    this._renderMenu = this._renderMenu.bind(this)
  }

  _renderMenu(results, menuProps, state) {
    const items = results.map((result, index) => (
      <Fragment key={result.value}>
        <MenuItem key={index} option={result} position={index}>
          <Highlighter search={state.text}>{result.label}</Highlighter>
        </MenuItem>
      </Fragment>
    ))

    return <Menu {...menuProps}>{items}</Menu>
  }

  render() {
    const {
      options,
      disabled,
      errors,
      placeholder,
      className,
      endpointUrl,
      isLoading,
      selectedRecords,
      inputName,
      initialDisplay,
      initialValues,
      extraRansackQuery
    } = this.state

    const handleOnChange = items => {
      this.setState({ selectedRecords: items })
    }

    return (
      <Fragment>
        <AsyncTypeahead
          placeholder={placeholder}
          id={'select-or-free-text'}
          renderMenu={this._renderMenu}
          filterBy={['label']}
          clearButton={!disabled}
          onChange={items => handleOnChange(items)}
          multiple
          defaultSelected={initialValues}
          className={className}
          minLength={initialDisplay ? 0 : 1}
          onFocus={event => {
            if (event.target.value === '' && initialDisplay) {
              this.setState({ isLoading: true })
              const request = new FetchRequest('GET', endpointUrl, { responseKind: 'json' })
              request.perform().then(async response => {
                if (response.ok) {
                  const data = await response.json
                  this.setState({
                    isLoading: false,
                    options: data
                  })
                }
              })
            }
          }}
          inputProps={{ autoComplete: 'typeahead-input' }}
          isLoading={isLoading}
          labelKey='label'
          onSearch={query => {
            this.setState({ isLoading: true })
            const url = `${endpointUrl}?q[name_cont]=${query}&${extraRansackQuery}`
            const request = new FetchRequest('GET', url, { responseKind: 'json' })
            request.perform().then(async response => {
              if (response.ok) {
                const data = await response.json
                this.setState({
                  isLoading: false,
                  options: data
                })
              }
            })
          }}
          options={options}
        />
        {errors && <Error error={errors} />}
        {selectedRecords && selectedRecords.length > 0 ? (
          <>
            {selectedRecords.map(value => (
              <input
                key={value.value}
                name={`${inputName}[]`}
                className='form-control hidden'
                type='hidden'
                value={value.value}
              />
            ))}
          </>
        ) : (
          <input key={0} name={`${inputName}[]`} className='form-control hidden' type='hidden' value={''} />
        )}
      </Fragment>
    )
  }
}
